import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button } from "react-bootstrap";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFViewer = ({ signedUrl }) => {
  const [numPages, setNumPages] = useState(null);
  const [pagesToRender, setPagesToRender] = useState(10); // Initially set to render only first 10 pages

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const loadMorePages = () => {
    setPagesToRender((prev) => Math.min(prev + 10, numPages));
  };

  return (
    <div>
      <Document
        file={signedUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        className="border mb-2"
      >
        {Array.from({ length: pagesToRender }, (_, index) => (
          <Page key={index} pageNumber={index + 1} className="border p-2" />
        ))}
      </Document>
      {pagesToRender < numPages && (
        <Button onClick={loadMorePages}>Load More Pages</Button>
      )}
    </div>
  );
};

export default PDFViewer;
